import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-ink" data-id="element-56" data-mp="1hd1p22n39g1m">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "17px",
      paddingBottom: "17px"
    }} data-id="element-57" data-mp="1cei0duh41q5k">
        <h2 className="text-center font-display text-3xl font-bold uppercase text-fog sm:text-4xl" data-id="element-58" data-mp="2a28nz2qgg7ne">❓ Frequently Asked Questions</h2>
        <div className="mt-9 divide-y divide-line overflow-hidden rounded-2xl border border-line bg-ink-2" data-id="element-59" data-mp="254726a1n9u88">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-60" data-mp="1v5hj4dy0i3qe" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-ink-3 focus:outline-none focus-visible:bg-ink-3 sm:px-6" data-id="element-61" data-mp="1v46eyd0nmtyr">
                  <span className="text-sm font-bold text-fog sm:text-base" data-id="element-62" data-mp="1korujopt68l7">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-63" data-mp="1pls0lzmnrbcb" /> : <PlusIcon className="h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-64" data-mp="1apstosbabh8r" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-200 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-65" data-mp="1fnuebhoczomc">
                  <div className="overflow-hidden" data-id="element-66" data-mp="11ve5u1couye1">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-fog/70 sm:px-6" data-id="element-67" data-mp="16oqugbhdb56s">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}